import { useId, useState, type ReactNode } from 'react';
import { Icon } from './Icon';
import { cn } from './cn';

/** Accordion row. The panel stays mounted and animates its height; `inert` keeps it out of the tab order while closed. */
export function Disclosure({
  summary,
  children,
  defaultOpen = false,
  className,
}: {
  summary: string;
  children: ReactNode;
  defaultOpen?: boolean;
  className?: string;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const panel = useId();
  return (
    <div className={cn('rounded-[16px] border bg-paper shadow-card transition-colors', open ? 'border-turquoise/40 shadow-sm' : 'border-line', className)}>
      <button
        type="button"
        aria-expanded={open}
        aria-controls={panel}
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-[16px] px-4 py-3 text-start font-bold text-navy transition-colors hover:text-action"
      >
        <span>{summary}</span>
        <Icon name="chevronDown" size={18} className={cn('shrink-0 text-ink-3 transition-transform duration-300', open && 'rotate-180 text-action')} />
      </button>
      <div id={panel} inert={!open} className={cn('grid transition-[grid-template-rows] duration-300 ease-out', open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]')}>
        <div className="overflow-hidden">
          <div className="border-t border-line-subtle p-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
